module.exports = __webpack_public_path__ + "static/media/iys.63e92ed6.png";